/* WEEGO · Formulario contra entrega (Releasit) a la medida.
   Releasit reconstruye el formulario cada vez que se abre: aquí lo vestimos de nuevo.
   Si algo falla, se queda el formulario original de Releasit. */
(function () {
  var cfg = window.wgCod || {};
  var WA = String(cfg.whatsapp || '').replace(/\D/g, '');
  var OFF = WA ? (parseInt(cfg.transfer, 10) || 0) / 100 : 0;
  var SERVINGS = cfg.servings || 17;

  var SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var ICON = {
    truck: SVG + '<path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    cash: SVG + '<rect x="2.5" y="6" width="19" height="12" rx="2"/><circle cx="12" cy="12" r="2.6"/><path d="M6 9.5v5M18 9.5v5"/></svg>',
    lock: SVG + '<rect x="4.5" y="10.5" width="15" height="10" rx="2.5"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/></svg>',
    wa: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.6 0-3.1-.4-4.4-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1-.7-.3-1.5-.8-2.1-1.4-.6-.6-1-1.2-1.2-1.6-.1-.2 0-.4.1-.5l.4-.4.2-.4c.1-.1 0-.3 0-.4l-.8-1.9c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.4.1-.6.3-.2.2-.8.8-.8 2s.9 2.3 1 2.5c.1.2 1.7 2.6 4.2 3.6 1.5.6 2.1.7 2.9.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.1-1.2l-.4-.3z"/></svg>',
    gift: SVG + '<rect x="3.5" y="8" width="17" height="4" rx="1"/><path d="M5 12v8h14v-8M12 8v12M12 8S10.5 4 8 4.5 7.5 8 12 8zM12 8s1.5-4 4-3.5S16.5 8 12 8z"/></svg>'
  };
  var HINTS = {
    phone: 'Te escribimos solo para confirmar tu pedido.',
    address: 'Calle o carrera, número y casa o apto.'
  };

  function money(n) { return '$' + Math.round(n).toLocaleString('es-CO'); }
  function perCup(total, cups) { return money(Math.floor(total / cups)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function tidy(el) { if (el && el.children.length === 0 && /,00\b/.test(el.textContent)) el.textContent = el.textContent.replace(/,00\b/g, ''); }
  function tubsOf(title) { var m = String(title).match(/(\d+)\s*tarro/i); return m ? parseInt(m[1], 10) : 0; }

  function orderTotal(form) {
    var t = form.querySelector('[data-checkout-line="total"]');
    var n = t ? parseInt(t.getAttribute('data-order-total'), 10) : NaN;
    if (!isNaN(n)) return n / 100;
    var s = form.querySelector('.rsi-cod-form-submit-total-value');
    return s ? parseInt(s.textContent.replace(/,\d{2}\b/, '').replace(/\D/g, ''), 10) || 0 : 0;
  }

  function header(form) {
    var head = form.querySelector('._rsi-modal-header');
    if (!head || form.querySelector('.wg-cod-head')) return;
    var title = head.querySelector('._rsi-modal-header-title');
    if (title) title.removeAttribute('style');
    head.insertAdjacentHTML('afterend',
      '<div class="wg-cod-head">' +
        '<p class="wg-cod-head__sub">Pídelo en 1 minuto. <b>Pagas cuando te llegue</b>, sin anticipos.</p>' +
        '<ul class="wg-cod-trust">' +
          '<li>' + ICON.truck + '<span>Envío gratis</span></li>' +
          '<li>' + ICON.cash + '<span>Pagas al recibir</span></li>' +
          '<li>' + ICON.wa + '<span>Confirmamos por WhatsApp</span></li>' +
        '</ul>' +
      '</div>');
  }

  // Releasit pinta su propia línea de descuento (en inglés): se traduce y, si existe, no se agrega otra.
  function discountLine(form) {
    var found = false;
    form.querySelectorAll('._rsi-modal-checkout-line-title').forEach(function (el) {
      var node = Array.prototype.find.call(el.childNodes, function (n) { return n.nodeType === 3 && /discount/i.test(n.textContent); });
      if (node) { node.textContent = 'Descuento por cantidad '; found = true; }
      else if (/descuento/i.test(el.textContent)) found = true;
    });
    return found;
  }

  function savings(form) {
    if (discountLine(form)) { var dup = form.querySelector('.wg-save'); if (dup) dup.remove(); return; }
    var total = 0;
    form.querySelectorAll('._rsi-modal-line-item[data-wg-save]').forEach(function (li) { total += parseFloat(li.getAttribute('data-wg-save')) || 0; });
    var lines = form.querySelector('._rsi-modal-checkout-lines');
    var totalLine = form.querySelector('[data-checkout-line="total"]');
    if (!lines || !totalLine || total <= 0 || form.querySelector('.wg-save')) return;
    totalLine.insertAdjacentHTML('beforebegin', '<div class="wg-save"><span>Ahorro del pack</span><span>-' + money(total) + '</span></div>');
  }

  function cart() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  // En la página del producto, sugiere la siguiente cantidad (window.wgPacks la pone el hero) y la cambia sin cerrar.
  function upsell(form, li, info) {
    var packs = window.wgPacks || [];
    if (form.querySelector('.wg-up') || form.querySelectorAll('._rsi-modal-line-item').length !== 1 || !packs.length) return;
    var next = null;
    packs.forEach(function (k) { if (!next && k.q > info.tarros) next = k; });
    var summary = form.querySelector('._rsi-build-block-order-summary');
    if (!next || !summary || info.tubs !== 1) return;
    var more = next.t - info.price;
    var save = info.unit * next.q - next.t;
    summary.insertAdjacentHTML('afterend',
      '<div class="wg-up">' +
        '<span class="wg-up__ico">' + ICON.gift + '</span>' +
        '<p><b>Lleva ' + next.q + ' tarros por ' + money(more) + ' más</b>' +
          (save > 0 ? '<span>y ahorras ' + money(save) + '</span>' : '') +
          '<small>Te sale a ' + perCup(next.t, next.q * SERVINGS) + ' por vaso</small>' +
        '</p>' +
        '<button type="button" class="wg-up__btn">Cambiar</button>' +
      '</div>');
    var btn = form.querySelector('.wg-up__btn');
    btn.addEventListener('click', function () {
      var radio = document.querySelector('.w2-pack input[value="' + next.q + '"]');
      if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      var rsi = window._rsi;
      var qh = rsi && rsi.form && rsi.form.quantityHandlers;
      // El mismo cambio de cantidad que usa Releasit: actualiza el carrito y redibuja el formulario abierto.
      if (qh && typeof qh.updateVariant === 'function') {
        btn.disabled = true;
        btn.textContent = '...';
        qh.updateVariant(String(info.variant), next.q);
        return;
      }
      var close = document.getElementById('_rsi-cod-form-modal-close');
      var cta = document.querySelector('#w2-form button[name="add"]');
      if (close) close.click();
      if (cta) setTimeout(function () { cta.click(); }, 1200);
    });
  }

  function summary(form) {
    form.querySelectorAll('._rsi-modal-line-item-final-price, ._rsi-modal-checkout-line-value, ._rsi-modal-checkout-line-price').forEach(tidy);
    form.classList.toggle('wg-one-rate', form.querySelectorAll('._rsi-modal-shipping-rates-item').length === 1);
    discountLine(form);
    var fresh = [];
    form.querySelectorAll('._rsi-modal-line-item').forEach(function (li) {
      if (li.hasAttribute('data-wg')) return;
      li.setAttribute('data-wg', '');
      fresh.push(li);
      // Se vende por cantidad: la píldora muestra el total de tarros y el número de Releasit sobra.
      var q = li.querySelector('input[name^="item_quantity"]');
      var qty = q ? parseInt(q.value, 10) || 1 : 1;
      var pill = li.querySelector('._rsi-modal-line-item-variant-name');
      var badge = li.querySelector('._rsi-modal-line-item-quantity');
      var tubs = pill ? tubsOf(pill.textContent) : 0;
      if (pill && tubs) {
        var n = tubs * qty;
        pill.textContent = n + (n === 1 ? ' tarro' : ' tarros');
        li.setAttribute('data-wg-tarros', n);
        if (badge) badge.classList.add('wg-hide');
      } else if (badge) {
        if (qty === 1) badge.classList.add('wg-hide');
        else badge.textContent = '×' + qty;
      }
    });
    if (!fresh.length) return;
    cart().then(function (c) {
      if (!c || !c.items) return;
      fresh.forEach(function (li) {
        if (!li.isConnected) return;
        var vid = li.getAttribute('data-line-item-variant-id');
        var item = null;
        c.items.forEach(function (x) { if (String(x.variant_id) === vid) item = x; });
        if (!item) return;
        var price = item.final_line_price / 100;
        var unit = item.original_price / 100;
        var compare = Math.max(item.original_line_price, (item.compare_at_price || 0) * item.quantity) / 100;
        if (compare <= price) compare = 0;
        var priceEl = li.querySelector('._rsi-modal-line-item-final-price');
        if (priceEl) priceEl.innerHTML = (compare ? '<s>' + money(compare) + '</s>' : '') + money(price);
        var tubs = tubsOf(item.variant_title || '') || 1;
        var tarros = tubs * item.quantity;
        var meta = [tarros * SERVINGS + ' vasos · ' + perCup(price, tarros * SERVINGS) + ' c/u'];
        if (compare) { meta.push('<b>Ahorras ' + money(compare - price) + '</b>'); li.setAttribute('data-wg-save', compare - price); }
        var info = li.querySelector('._rsi-modal-line-item-info');
        if (info && !info.querySelector('.wg-li__meta')) info.insertAdjacentHTML('beforeend', '<span class="wg-li__meta">' + meta.join('<i>·</i>') + '</span>');
        savings(form);
        upsell(form, li, { variant: item.variant_id, tubs: tubs, tarros: tarros, price: price, unit: unit });
      });
    });
  }

  function steps(form) {
    if (form.querySelector('.wg-step')) return;
    var first = form.querySelector('._rsi-modal-fields-item input, ._rsi-modal-fields-item select');
    form.querySelectorAll('._rsi-build-block-custom-text').forEach(function (b) {
      var n = b.nextElementSibling;
      while (n && !n.classList.length) n = n.nextElementSibling;
      if (n && n.classList.contains('_rsi-build-block-submit-button')) { b.classList.add('wg-hide'); return; }
      var isFirst = first && (b.compareDocumentPosition(first) & Node.DOCUMENT_POSITION_FOLLOWING) && !form.querySelector('.wg-step');
      if (isFirst) b.innerHTML = '<h3 class="wg-step"><span>1</span>' + esc(b.textContent.trim()) + '</h3>';
    });
  }

  function valid(inp) {
    var v = (inp.value || '').trim();
    if (!v) return false;
    if (inp.name === 'phone') return v.replace(/\D/g, '').replace(/^57/, '').length === 10;
    if (inp.type === 'email') return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    return v.length >= (parseInt(inp.getAttribute('data-minl'), 10) || 1);
  }

  function fields(form) {
    form.querySelectorAll('._rsi-modal-fields-item').forEach(function (it) {
      var inp = it.querySelector('input:not([type="checkbox"]):not([type="hidden"]), select');
      if (!inp || it.classList.contains('wg-f')) return;
      it.classList.add('wg-f', 'wg-f--' + inp.name);
      if (HINTS[inp.name]) it.insertAdjacentHTML('beforeend', '<small class="wg-f__hint">' + HINTS[inp.name] + '</small>');
      var check = function () { it.classList.toggle('wg-ok', valid(inp)); };
      inp.addEventListener('input', check);
      inp.addEventListener('change', check);
      inp.addEventListener('blur', check);
      check();
    });
    // Departamento y ciudad lado a lado
    var prov = form.querySelector('.wg-f--province, .wg-f--province_country_field');
    var city = form.querySelector('.wg-f--city');
    if (prov && city && !prov.parentNode.classList.contains('wg-row')) {
      var row = document.createElement('div');
      row.className = 'wg-row';
      prov.parentNode.insertBefore(row, prov);
      row.appendChild(prov);
      row.appendChild(city);
    }
  }

  function option(kind, icon, title, sub, price) {
    return '<button type="button" class="wg-pay__opt wg-pay__opt--' + kind + '" role="radio" aria-checked="false" data-pay="' + kind + '">' +
      '<span class="wg-pay__radio"></span>' +
      '<span class="wg-pay__ico">' + icon + '</span>' +
      '<span class="wg-pay__txt"><b>' + title + '</b><small>' + sub + '</small></span>' +
      '<span class="wg-pay__price">' + price + '</span>' +
    '</button>';
  }

  function payment(form) {
    var block = form.querySelector('._rsi-build-block-submit-button');
    if (!block || form.querySelector('.wg-pay')) return;
    block.insertAdjacentHTML('beforebegin',
      '<div class="wg-pay" role="radiogroup" aria-label="Método de pago">' +
        '<h3 class="wg-step"><span>2</span>¿Cómo prefieres pagar?</h3>' +
        option('cod', ICON.cash, 'Pago contra entrega', 'En efectivo cuando te llegue', '<b data-wg-price="cod"></b>') +
        (OFF ? option('wa', ICON.wa, 'Por WhatsApp <em>-' + Math.round(OFF * 100) + '%</em>', 'Pagas por transferencia a tu asesora', '<s data-wg-price="full"></s><b data-wg-price="wa"></b>') : '') +
      '</div>');
    block.insertAdjacentHTML('afterend',
      '<div class="wg-cta">' +
        '<button type="button" class="wg-cta__btn" data-wg-cta><span class="wg-cta__main"></span><span class="wg-cta__sub"></span></button>' +
        '<p class="wg-cta__safe">' + ICON.lock + '<span>Datos protegidos · te confirmamos por WhatsApp antes de enviar</span></p>' +
        (cfg.invima ? '<p class="wg-cta__reg">Registro sanitario INVIMA <b>' + esc(cfg.invima) + '</b></p>' : '') +
        (WA ? '<a class="wg-cta__help" href="https://wa.me/' + WA + '" target="_blank" rel="noopener">¿Dudas? Escríbenos por WhatsApp</a>' : '') +
      '</div>');
    setPay(form, form.getAttribute('data-wg-pay') || 'cod');
  }

  function setPay(form, kind) {
    if (!form.querySelector('.wg-pay__opt--' + kind)) kind = 'cod';
    form.setAttribute('data-wg-pay', kind);
    form.querySelectorAll('.wg-pay__opt').forEach(function (o) {
      var on = o.getAttribute('data-pay') === kind;
      o.classList.toggle('is-on', on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    prices(form);
  }

  function prices(form) {
    var total = orderTotal(form);
    var waTotal = total * (1 - OFF);
    // Solo se escribe si cambia: cada escritura dispara el observador.
    var set = function (sel, txt) { var el = form.querySelector(sel); if (el && el.textContent !== txt) el.textContent = txt; };
    if (total) {
      set('[data-wg-price="cod"]', money(total));
      set('[data-wg-price="full"]', money(total));
      set('[data-wg-price="wa"]', money(waTotal));
    }
    var btn = form.querySelector('[data-wg-cta]');
    if (!btn) return;
    var wa = form.getAttribute('data-wg-pay') === 'wa';
    btn.classList.toggle('wg-cta__btn--wa', wa);
    set('.wg-cta__main', wa
      ? (total ? 'Pedir por WhatsApp · ' + money(waTotal) : 'Pedir por WhatsApp')
      : (total ? 'Confirmar pedido · ' + money(total) : 'Confirmar pedido'));
    set('.wg-cta__sub', wa
      ? (total ? 'Pagas por transferencia · ahorras ' + money(total - waTotal) : 'Pagas por transferencia')
      : 'Pagas al recibir · envío gratis');
  }

  // Pedido por WhatsApp: la asesora recibe el pack, el precio con descuento y los datos que ya llenó.
  function whatsapp(form) {
    var total = orderTotal(form);
    var items = form.querySelectorAll('._rsi-modal-line-item');
    var pedido = Array.prototype.map.call(items, function (li) {
      var title = (li.querySelector('._rsi-modal-line-item-title') || {}).textContent || '';
      var variant = (li.querySelector('._rsi-modal-line-item-variant-name') || {}).textContent || '';
      var q = li.querySelector('input[name^="item_quantity"]');
      var qty = q ? parseInt(q.value, 10) || 1 : 1;
      var counted = li.hasAttribute('data-wg-tarros');
      return (items.length > 1 || !variant ? title.trim() + ' ' : '') + variant.trim() + (qty > 1 && !counted ? ' x' + qty : '');
    }).join(', ');
    var msg = String(cfg.message || 'Hola WEEGO, quiero pedir {pedido} y pagar por transferencia: {total_dto}.')
      .replace('{pedido}', pedido).replace('{total_dto}', money(total * (1 - OFF)))
      .replace('{total}', money(total)).replace('{descuento}', Math.round(OFF * 100));
    var val = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el && el.value ? el.value.trim() : ''; };
    var prov = form.querySelector('[data-type="province_country_field"]');
    var provTxt = prov && prov.value ? prov.options[prov.selectedIndex].text : '';
    var place = [val('city'), provTxt].filter(Boolean).join(', ');
    var datos = [val('first_name'), val('address'), val('civic_number'), place].filter(Boolean);
    if (datos.length) msg += '\n\nMis datos: ' + datos.join(' · ');
    window.open('https://wa.me/' + WA + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
  }

  function go(form) {
    var btn = form.querySelector('[data-wg-cta]');
    if (!btn || btn.classList.contains('is-loading')) return;
    if (form.getAttribute('data-wg-pay') === 'wa') { whatsapp(form); return; }
    var target = form.querySelector('._rsi-build-block-submit-button button[type="submit"]');
    if (!target) return;
    btn.classList.add('is-loading');
    target.click();
    setTimeout(function () {
      var err = form.querySelector('._rsi-modal-fields-item-error');
      if (!err) return;
      btn.classList.remove('is-loading');
      err.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var f = err.querySelector('input, select');
      if (f) f.focus({ preventScroll: true });
    }, 150);
    setTimeout(function () { btn.classList.remove('is-loading'); }, 8000);
  }

  // Escuchas que viven en el <form>: Releasit cambia su contenido pero no el elemento.
  function bind(form) {
    if (form.__wg) return;
    form.__wg = true;
    form.addEventListener('click', function (e) {
      var opt = e.target.closest('.wg-pay__opt');
      if (opt) { setPay(form, opt.getAttribute('data-pay')); return; }
      if (e.target.closest('[data-wg-cta]')) go(form);
    });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('input:not([type="checkbox"])') && form.querySelector('[data-wg-cta]')) {
        e.preventDefault();
        go(form);
      }
    });
    form.addEventListener('change', function () { setTimeout(function () { summary(form); prices(form); }, 60); });
  }

  function enhance(form) {
    if (!form.querySelector('._rsi-build-block-submit-button')) return;
    // Releasit pinta el resumen y los totales después: esas partes se repasan en cada cambio.
    if (form.querySelector('.wg-pay') && form.classList.contains('wg-cod')) { summary(form); prices(form); return; }
    form.classList.remove('wg-cod');
    try {
      header(form);
      summary(form);
      steps(form);
      fields(form);
      payment(form);
      form.classList.add('wg-cod');
    } catch (err) {
      form.classList.remove('wg-cod');
      if (window.console) console.warn('[WEEGO] formulario contra entrega:', err);
    }
  }

  // Releasit crea y reemplaza el popup cuando quiere, así que se busca de nuevo en cada cambio.
  var queued = false;
  function run() {
    queued = false;
    var modal = document.getElementById('_rsi-cod-form-modal');
    if (!modal) return;
    if (modal.classList.contains('_rsi-cod-form-modal-open')) {
      document.querySelectorAll('.w2-btn.is-loading').forEach(function (b) { b.classList.remove('is-loading'); });
    }
    var form = modal.querySelector('form._rsi-modal-form');
    if (!form) return;
    bind(form);
    enhance(form);
  }
  function queue() { if (!queued) { queued = true; setTimeout(run, 16); } }
  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  run();
})();
